import React from 'react';
import { Tag } from 'antd';
import moment from 'moment';
import { truncate } from 'lodash';

const renderDate = (val) => <span>{moment(val).format('MMM Do YYYY')}</span>;
const renderCohort = (cohort) => <Tag color="orange">{cohort?.name ?? '—'}</Tag>;
// A count from the server, not a list to measure: every assigned learner has
// a row, so the length of that list would be the class size.
const renderSubmission = (count) => <Tag color="green">{count ?? 0}</Tag>;
const renderSubject = (val) => (
  <>
    {val && val.map(({ id, name }) => <Tag color="blue" key={id}>{name}</Tag>)}
  </>
);
const renderAuthor = (author) => (
  <span>
    {author ? truncate(`${author.firstName} ${author.lastName}`, { length: 50 }) : '—'}
  </span>
);

export default [
  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: renderDate,
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Author',
    dataIndex: 'creator',
    key: 'creator',
    render: renderAuthor,
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Cohort',
    dataIndex: 'cohort',
    key: 'cohort',
    render: renderCohort,
  },
  {
    title: 'Subjects',
    dataIndex: 'subjects',
    key: 'subject',
    render: renderSubject,
  },
  {
    title: 'Submission',
    dataIndex: 'submissionCount',
    key: 'submissionCount',
    render: renderSubmission,
  },
];

export const instructorColumns = [
  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: renderDate,
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Cohort',
    dataIndex: 'cohort',
    key: 'cohort',
    render: renderCohort,
  },
  {
    title: 'Subjects',
    dataIndex: 'subjects',
    key: 'subject',
    render: renderSubject,
  },
  {
    title: 'Submission',
    dataIndex: 'submissionCount',
    key: 'submissionCount',
    render: renderSubmission,
  },
];
